module.exports = __webpack_public_path__ + "img/classification6.9226ac92.png";